import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventRcsVideoUploadError } from 'entities/Rcs/api/rcsComplianceTypes'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseEventRcsVideoUploadError) => void

export const useEventRcsVideoUploadError = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.RcsVideoUploadError, handler), [])
}
